<template>
  <section class="modal share-quiz-modal" @click="hideShareSheet">
        <div class="modal-card" @click.stop>
            <div class="modal-head">
                <div class="circle-btn close-circle-btn" @click="hideShareSheet"></div>
                <h1>Share Quiz</h1>
            </div>
            <div class="modal-body">
                <img
                class="share-sheet-img"
                :src="gifURL"
                alt="" srcset="">
                <div class="modal-btns-cont share-sheet-btns">
                    <h3 class="share-sheet-btns-header">Share quiz on</h3>
                    <a target="_blank"
                        :href="whatsappShareLink+fullPostURL"
                        class="btn btn-l btn-secondary btn-icon-16 btn-icon-whatsapp share-btn">
                        Whatsapp
                    </a>
                    <a target="_blank"
                        :href="telegramShareLink+fullPostURL"
                        class="btn btn-l btn-secondary btn-icon-16 btn-icon-telegram share-btn">
                        Telegram
                    </a>
                    <a target="_blank"
                        :href="facebookShareLink+fullPostURL"
                        class="btn btn-l btn-secondary btn-icon-16 btn-icon-facebook share-btn">
                        Facebook
                    </a>
                    <a target="_blank"
                        :href="twitterShareLink+fullPostURL"
                        class="btn btn-l btn-secondary btn-icon-16 btn-icon-twitter share-btn">
                        Twitter
                    </a>
                    <a
                        @click.prevent="copyToClipboard($refs.postURLInput)"
                        :href="fullPostURL"
                        class="btn btn-l btn-secondary btn-icon-16 btn-icon-copy share-btn copy-to-clipboard-btn">
                        Copy link to quiz
                        <div
                            :class="[linkCopied ? 'link-copied-popover link-copied-popover-shown' : 'link-copied-popover']">
                            Link Copied!
                        </div>
                    </a>
                    <input class="copied-text-input" ref="postURLInput" type="text" :value="fullPostURL" readonly>
                </div>
                <a class="back-to-home-link" href="./" @click.prevent="hideShareSheet">Cancel</a>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "shareSheet",
    props: {
        postID: String,
        gifURL: String,
    },
    data() {
        return {
            facebookShareLink: "https://www.facebook.com/sharer/sharer.php?u=",
            twitterShareLink: "https://twitter.com/intent/tweet?text=",
            whatsappShareLink: "https://wa.me/?text=",
            telegramShareLink: "https://t.me/share/url?url=",
            fullPostURL: document.location.origin + "/post/" + this.postID,
            linkCopied: false,
        }
    },
    watch: {
        postID: function(val) { // watch changes to post ID and update post URL
            this.fullPostURL = document.location.origin + "/post/" + val
        },
    },
    methods: {
        hideShareSheet() {
            this.$emit('hideShareSheet');
        },
        copyToClipboard(inputElement) {
            inputElement.select();
            inputElement.setSelectionRange(0, 99999);
            document.execCommand('copy');
            this.linkCopied = true;
            let timer = setTimeout(() => {
                this.linkCopied = false;
                clearTimeout(timer);
            }, 2500);
        }
    }
}
</script>

<style>

</style>